import { createAsyncThunk } from '@reduxjs/toolkit';
import * as ContactsApi from '@sophocles/api/contacts';

export const loadContacts = createAsyncThunk('contacts/load', async (filters, { rejectWithValue }) => {
  try {
    const response = await ContactsApi.fetchContactsAPI(filters);
    // fetchContactsAPI now returns full response with results array
    const data = response.results || response;
    return { data, filterKey: JSON.stringify(filters) };
  } catch (e) {
    return rejectWithValue(e.response?.data || e.message);
  }
});

// Removed markPrimaryRma - use updateContact with is_primary_rma_billing, is_primary_rma_shipping, is_primary_sales_billing, or is_primary_sales_shipping instead

export const createContact = createAsyncThunk('contacts/create', async (contactData, { rejectWithValue }) => {
  try {
    const data = await ContactsApi.createContactAPI(contactData);
    return data;
  } catch (e) {
    return rejectWithValue(e.response?.data || e.message);
  }
});

export const deleteContact = createAsyncThunk('contacts/delete', async (contactId, { rejectWithValue }) => {
  try {
    await ContactsApi.deleteContactAPI(contactId);
    return contactId;
  } catch (e) {
    return rejectWithValue(e.response?.data || e.message);
  }
});

export const restoreContact = createAsyncThunk('contacts/restore', async (contactId, { rejectWithValue }) => {
  try {
    const data = await ContactsApi.restoreContactAPI(contactId);
    return data;
  } catch (e) {
    return rejectWithValue(e.response?.data || e.message);
  }
});

export const updateContact = createAsyncThunk(
  'contacts/update',
  async ({ id, ...contactData }, { rejectWithValue }) => {
    try {
      const data = await ContactsApi.updateContactAPI(id, contactData);
      return data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);
